var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurveyDirector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 101,
    viewBox: "0 0 143 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.84 24.033a2.909 2.909 0 0 1 2.908 2.908v48.572a2.909 2.909 0 0 1-5.817 0V26.941a2.909 2.909 0 0 1 2.909-2.908z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 4a4 4 0 0 1 4-4h33a4 4 0 0 1 4 4v30a4 4 0 0 1-4 4H55a4 4 0 0 1-4-4V4z",
    fill: "#5959EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58 10.75C58 9.231 59.023 8 60.286 8h23.428C84.977 8 86 9.231 86 10.75v5.5c0 1.519-1.023 2.75-2.286 2.75H60.286C59.023 19 58 17.769 58 16.25v-5.5z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.033 50.21a2.908 2.908 0 0 1 2.908-2.91H122.74a2.908 2.908 0 0 1 2.908 2.91v31.702a2.908 2.908 0 1 1-5.817 0V53.118H23.85v28.794a2.909 2.909 0 0 1-5.817 0V50.209z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 67a4 4 0 0 1 4-4h34a4 4 0 0 1 4 4v30a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V67z",
    fill: "#19D89F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101 67a4 4 0 0 1 4-4h34a4 4 0 0 1 4 4v30a4 4 0 0 1-4 4h-34a4 4 0 0 1-4-4V67z",
    fill: "#FFD630"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67a4 4 0 0 1 4-4h33a4 4 0 0 1 4 4v30a4 4 0 0 1-4 4H55a4 4 0 0 1-4-4V67z",
    fill: "#BF3DC2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 73a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-7z",
    fill: "#5959EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58 73a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H60a2 2 0 0 1-2-2v-7z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109 73a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-24a2 2 0 0 1-2-2v-7z",
    fill: "#424F9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyDirector);
export default __webpack_public_path__ + "static/media/survey-director.bd544da604ff7c725a7ffe91b42eb6b7.svg";
export { ForwardRef as ReactComponent };